import gql from 'graphql-tag';

// Extraemos información
export const findTimeSerie = gql`
query findTimeSerie($dispositivo: [String], $from: Float, $to: Float, $limit: Int, $tipoDato: [String] ) {
    findTimeSerie(dispositivo: $dispositivo, from: $from, to:$to, limit: $limit, tipoDato:$tipoDato) {
        dispositivo
        tipoDato
        dato
        fecha
        valor
  }
}
`